import { render, staticRenderFns } from "./thaipost.vue?vue&type=template&id=69fab094"
import script from "./thaipost.vue?vue&type=script&lang=js"
export * from "./thaipost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports